import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import Content from './components/Content';
import Website from './components/Website';
import Wrapper from './styled';

const ToolParams = ({ defaultParams, currentTool, onChangeField }) => {
  const [tool, setTool] = useState(currentTool);

  useEffect(() => {
    setTool(currentTool);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTool?.name]);

  if (isEmpty(currentTool)) return null;

  return (
    <Wrapper>
      <Website currentTool={ tool } />
      <Content defaultParams={ defaultParams } currentTool={ tool } onChangeField={ onChangeField } />
    </Wrapper>
  );
};

export default ToolParams;
